module.exports = __webpack_public_path__ + "static/media/icon_question.4ea1ca76.svg";